module.exports = __webpack_public_path__ + "img/02.fdbdf3e1.jpg";